import { useCallback, useContext } from 'react';
import useHttp from './useHttp';
import AuthContext from '../context/authContext';

function useOnlineCustomer() {
  const authCtx = useContext(AuthContext);
  const { sendRequest } = useHttp();

  const authHeaders = useCallback(
    () => ({
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + authCtx.token,
    }),
    [authCtx.token]
  );

  const getOnlineCustomers = useCallback(
    async ({ page = 1, limit = 50, search = '' } = {}) => {
      const params = new URLSearchParams({ page, limit });
      if (search) params.set('search', search);
      return sendRequest({
        url: `/api/v1/online-customer?${params.toString()}`,
        method: 'GET',
        headers: authHeaders(),
      });
    },
    [sendRequest, authHeaders]
  );

  const getOnlineCustomerById = useCallback(
    async id => {
      return sendRequest({
        url: `/api/v1/online-customer/${id}`,
        method: 'GET',
        headers: authHeaders(),
      });
    },
    [sendRequest, authHeaders]
  );

  const patchOnlineCustomer = useCallback(
    async (id, data) => {
      return sendRequest({
        url: `/api/v1/online-customer/${id}`,
        method: 'PATCH',
        headers: authHeaders(),
        body: data,
      });
    },
    [sendRequest, authHeaders]
  );

  const deleteOnlineCustomer = useCallback(
    async id => {
      return sendRequest({
        url: `/api/v1/online-customer/${id}`,
        method: 'DELETE',
        headers: authHeaders(),
      });
    },
    [sendRequest, authHeaders]
  );

  return {
    getOnlineCustomers,
    getOnlineCustomerById,
    patchOnlineCustomer,
    deleteOnlineCustomer,
  };
}

export default useOnlineCustomer;
